module.exports = __webpack_public_path__ + "img/1. Male Nurse.a29d8789.png";